import { Translate } from "@omni/types/utils/translate";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import {
    NumberOfHitsContextValue,
    useNumberOfHitsContext
} from "../context/numberOfHits.context";
import { NumberOfHitsConfiguration } from "../numberOfHits.config";
import { NumberOfHitsConfigurationEntry } from "../numberOfHits.types";

const toNumberOfHitsEntry = (
    state: NumberOfHitsContextValue["state"],
    configurationEntry: NumberOfHitsConfigurationEntry,
    t: Translate
) => {
    const numberOfHits = state.find(
        (componentState) =>
            componentState?.component === configurationEntry.component
    )?.numberOfHits;

    if (!numberOfHits) return;

    return `<a href="#${
        configurationEntry.resultListId
    }" class="${cn("tw:underline tw:cursor-pointer tw:text-grey-dark")}">${numberOfHits}&nbsp;${t(
        configurationEntry.translationKey
    ).replaceAll(" ", "&nbsp;")}</a>`;
};

const NumberOfHitsComponent = () => {
    const { state } = useNumberOfHitsContext();
    const { t } = useGranite();

    const numberOfHitsEntries = NumberOfHitsConfiguration.map(
        (configurationEntry) =>
            toNumberOfHitsEntry(state, configurationEntry, t)
    ).filter((hitStat) => hitStat !== undefined);

    if (numberOfHitsEntries.length === 0) return null;

    const joinedNumberOfHits =
        numberOfHitsEntries.length > 1
            ? numberOfHitsEntries.slice(0, -1).join(", ") +
              " " +
              t("search.summary.stats.finalResult", numberOfHitsEntries.at(-1))
            : numberOfHitsEntries.at(0);

    return (
        <p
            className={cn("tw:mt-2 tw:mb-4")}
            dangerouslySetInnerHTML={{
                __html: t("search.summary.stats", joinedNumberOfHits)
            }}
        ></p>
    );
};

export { NumberOfHitsComponent };
